module.exports = __webpack_public_path__ + "static/media/blue-background.113d22a6.png";